<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" v-if="orderId" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" :before-open="beforeOpen" @error="error">
            <template slot="fileUrlType" slot-scope="{file}">
                <span>{{file.url}}</span>
            </template>
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <avue-crud :data="data" v-if="!orderId" :option="option" v-model="form" :table-loading="loading" :page.sync="page" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" :before-open="beforeOpen" @error="error">
            <template slot="fileUrlType" slot-scope="{file}">
                <span>{{file.url}}</span>
            </template>
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <div class="tac mt15" slot>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { remove, update, add } from "@/api/order/orderinit";
import { mapGetters } from "vuex";
import { getAttachFile } from "@/api/resource/oss"
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '具体执行情况'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加执行情况'
        },
        orderId: {
            type: String,
            default: ''
        },
        list: {
            type: Array
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        orderInitialPlanList: {
            type: Array
        }
    },
    data() {
        return {
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: true,
                viewBtn: true,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 120,
                menu: this.isOpt,
                column: [{
                        label: '计划单编号',
                        prop: 'initialPlanNo',
                        row: true,
                        disabled: true,
                        span: 24,
                        placeholder: '计划单编号自动生成'
                    },
                    // {
                    //     label: '选择计划单',
                    //     prop: 'xx',
                    //     row: true,
                    //     span: 24,
                    //     type: 'select',
                    //     dicData: this.orderInitialPlanList,
                    //     props: {
                    //         label: "orderInitNo",
                    //         value: "id"
                    //     },
                    //     rules: [{
                    //         required: true,
                    //         trigger: "blur"
                    //     }]
                    // },
                    {
                        label: "机构名称",
                        prop: "createDeptName",
                        dicUrl: "/api/blade-order/order/getDeptList",
                        props: {
                            label: "deptName",
                            value: "id"
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        display: false,
                        row: true,
                        span: 24,
                    },
                    {
                        label: '执行人',
                        prop: 'content',
                        row: true,
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请输入执行人",
                        }]
                    },
                    {
                        label: '建议转派机构',
                        prop: 'description',
                        row: true,
                        type: 'textarea',
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur",
                            message: "请输入建议转派机构",
                        }]
                    },
                    {
                        label: '内容',
                        prop: 'content',
                        row: true,
                        type: 'textarea',
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请输入内容",
                        }]
                    },
                    {
                        label: "上传pdf",
                        prop: "fileUrl",
                        type: 'upload',
                        dataType: 'string',
                        loadText: '文件上传中，请稍等',
                        tip: '只能上传pdf凭证文件，且不超过2MB',
                        action: '/api/blade-resource/oss/endpoint/put-file-attach-by-name-new',
                        propsHttp: {
                            url: 'data',
                            name: '文件'
                        },
                        data: {
                            fileName: 'fileUrl'
                        },
                        span: 24,
                        hide: true,
                        // uploadBefore: () => {
                        //     makeBucket("/images").then(res => {
                        //         console.log(res)
                        //     })
                        // }
                    },
                    {
                        label: "上传图片",
                        prop: "imgList",
                        type: 'upload',
                        dataType: 'array',
                        listType: 'picture-card',
                        loadText: '图片上传中，请稍等',
                        tip: '只能上传jpg/png/pdf凭证图片，且不超过2MB',
                        action: '/api/blade-resource/oss/endpoint/put-file-attach',
                        propsHttp: {
                            res: 'data',
                            url: 'link'
                        },
                        // canvasOption: {
                        //     text: '公益项目信息化管理系统',
                        //     ratio: 0.1
                        // },
                        data: {
                            fileName: 'orderJudicialImagesList'
                        },
                        span: 24,
                        hide: true,
                        // uploadBefore: () => {
                        //     makeBucket("/images").then(res => {
                        //         console.log(res)
                        //     })
                        // }
                    },
                    {
                        label: '开始时间',
                        prop: 'beginTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '完成时间',
                        prop: 'endTime',
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '订单id',
                        prop: 'orderId',
                        display: false,
                        hide: true,
                        span: 24,
                        disabled: true
                    }
                ]
            }
        }
    },
    watch: {
        orderId() {
            this.form.orderId = this.orderId
        },
        list: {
            deep: true,
            handler(val) {
                this.data = this.list
            }
        },
        'form.imgList'() {
            if (!this.form.imgList) return
            this.form.orderJudicialImagesList = []
            this.form.imgList.map(v => {
                let json = {
                    imagesUrl: v
                }
                this.form.orderJudicialImagesList.push(json)
            })
        }
    },
    methods: {
        beforeOpen(done, type) {
            if (["edit", "view"].includes(type)) {
                let list = []
                this.form.orderJudicialImagesList.map(v => {
                    list.push(v.imagesUrl)
                })
                // let list1 = []
                // this.form.fileUrl.map(v => {
                //     list1.push({value:v})
                // })
                this.$set(this.form, 'imgList', list)
                // this.$set(this.form, 'fileUrl', list1)
            }
            done();
        },
        add() {
            this.$refs.crud.rowEdit()
        },
        rowSave(row, done, loading) {
            // let list = []
            // if (row.fileUrl && row.fileUrl.length > 0) {
            //     row.fileUrl.map(v => {
            //         list.push(v.value)
            //     })
            // }
            // row.fileUrl = list.join(",")
            if (!this.orderId) {
                this.data.push(row)
                done();
                this.$emit('getList', this.data)
                return
            }
            row.orderId = this.orderId
            add(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.data.push(res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowUpdate(row, index, done, loading) {
            let list = []
            row.imgList.map(v => {
                list.push({ imagesUrl: v })
            })
            this.$set(row, 'orderJudicialImagesList', list)
            if (!this.orderId) {
                this.$set(this.data, index, row)
                // [index] = row
                done();
                this.$emit('getList', this.data)
                return
            }
            update(row).then(() => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.$set(this.data, index, row)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowDel(row, index) {
            if (!this.orderId) {
                this.data.splice(index, 1)
                this.$emit('getList', this.data)
                return
            }
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return remove(row.id);
                })
                .then(() => {
                    this.data.splice(index, 1)
                    this.$emit('getList', this.data)
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        onLoad(page, params = {}) {
            this.loading = true;
            console.log(this.list)
            if ((this.list && this.list.length > 0) || !this.form.orderId) {
                this.data = this.list || []
                this.page.total = this.data.length;
                this.loading = false;
                return
            }
            // getDetail(this.orderId).then(res => {
            //     const data = res.data.data;
            //     this.page.total = data.total;
            //     this.data = data.records;
            //     this.loading = false;
            // });
        },error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
